import React from "react";
import NewsSection from "../../components/Media/News.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
// import PartnerWithAptechSection from "../components/PartnerWithAptech/PartnerWithAptech.tsx";
const News = () => {
  return (
    <div>
       <MetaComponent
        title="Aptech Limited Making News as a Global Vocational Training Company"
        desc="Discover Aptech Limited in the latest media news, where, as a leading vocational training company we are celebrated globally for our excellence. Check updates."
        keywords="vocational training, aptech news, aptech insights."
      />
      <NewsSection />
    </div>
  );
};

export default News;
